import { pdpTypeFormat, sanitizeTextForAnalytics } from "@/utils/helper"

const emptyCartEventInfo = (status, message) => ({
  eventAction: "cart:landing page:empty cart",
  eventName: "cart:landing page:empty cart",
  eventType: "navigation",
  eventMsg: status === "success" ? "n/a" : message,
  eventStatus: status,
  internalLinkName: "empty cart",
  internalLinkPosition: "cart",
  internalLinkType: "cart:navigation",
  internalLinkZoneName: "cart:landing page:cart items",
  internalLinkURL: "n/a",
  clickInternalLinks: "true",
})

export const continueShopGetEventInfo = continueShopUrl => {
  return JSON.stringify({
    eventAction: "cart preview:continue shopping",
    eventName: "cart preview:continue shopping",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "continue shopping",
    internalLinkPosition: "cart",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:preview",
    internalLinkURL:
      (continueShopUrl.indexOf("http") === -1 ? window.location.origin : "") +
      continueShopUrl,
    clickInternalLinks: "true",
  })
}
export const addAllToCartEventInfo = link => {
  const eventInfo = {
    eventAction: "cart:share cart landing page:add all to cart",
    eventName: "cart:share cart landing page:add all to cart",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "add all to cart",
    internalLinkPosition: "share cart",
    internalLinkType: "share cart:navigation",
    internalLinkZoneName: "cart:share cart landing page:order summary",
    internalLinkURL: link,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addMergeEventInfo = (type, link) => {
  const eventInfo = {
    eventAction: `cart:share cart landing page:add all to cart:${type}`,
    eventName: "cart:share cart landing page:add all to cart",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type,
    internalLinkPosition: "share cart",
    internalLinkType: "share cart:navigation",
    internalLinkZoneName: "cart:share cart landing page:order summary",
    internalLinkURL: link,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
const pushAnalyticsObjToDataLayer = (eventInfo = {}) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const event = "cmp:click"
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
  })
}

export const handleEmptyCartCallback = (status, message, res) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState ? getState("page") : {}
  if (status === "success" && res) {
    page.cart = {
      cartID: res.id || page.cart?.cartID || null,
      item: null,
      price: null,
    }
  }
  const eventInfo = emptyCartEventInfo(status, message)

  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}
export const getCartItemProductInfo = (siteName = "", data = {}) => {
  const {
    sku = "",
    desc = "",
    name = "",
    color = "",
    image = "",
    quantity = 0,
    category = "",
    unitPrice = 0,
    totalPrice = 0,
    availableQty = 0,
    superSku = false,
    outOfStock = false,
    discountPercent = 0,
    ProductIsRetail = "",
    businessUnitName = "",
    customerFacingSKU = "",
    discontinuedProductb = "",
    productCollectionsName = "",
    ProductRequiredAccessoriesGroupsList = "",
  } = data
  return JSON.stringify({
    productInfo: {
      productBrand: siteName.toLowerCase(),
      description: sanitizeTextForAnalytics(desc),
      globalPromotionPrice: totalPrice,
      priceState: `${
        discountPercent > 0 ? `percentOff|${discountPercent}` : "regular price"
      }`,
      productBasePrice: unitPrice,
      productCategory: sanitizeTextForAnalytics(category),
      productColor: sanitizeTextForAnalytics(color),
      productID: customerFacingSKU || sku,
      productName: sanitizeTextForAnalytics(name),
      productRoom: sanitizeTextForAnalytics(category),
      productSalePrice: totalPrice,
      productStatus:
        outOfStock && availableQty < 1 ? "out of stock" : "in stock",
      productSuperSku: superSku ? true : false,
      productTileName: sanitizeTextForAnalytics(name),
      quantity: quantity,
      defaultImageName: image,
      productCollectionsName: sanitizeTextForAnalytics(
        productCollectionsName || category
      ),
      productCoupondiscount: "n/a",
      productPartnerBuyNow: "true",
      productSaleable: "true",
      isRecommended: "true",
      isSendNow: "true",
      isSubscription: "true",
      frequency: "n/a",
      ratings: "n/a",
      numberOfReviews: "n/a",
      pdpType: pdpTypeFormat({
        businessUnitName: businessUnitName,
        ProductIsRetail: ProductIsRetail,
        discontinuedProductb: discontinuedProductb,
        ProductRequiredAccessoriesGroupsList:
          ProductRequiredAccessoriesGroupsList,
        superSku: superSku,
      }),
      productFindingMethod: "n/a",
    },
  })
}

export const multiFinishAddToCartBundleAnalytics = (
  previousBundleItems = [],
  selectedBundlesProdctList = []
) => {
  if (Object.keys(previousBundleItems).length === 0) {
    const bundlesLists = JSON.stringify(selectedBundlesProdctList)

    localStorage.setItem("bundleItems", bundlesLists)
  } else {
    const isExitingBundleItems = previousBundleItems.find(item => {
      return item.bundleId === selectedBundlesProdctList[0].bundleId
    })

    if (isExitingBundleItems) {
      const newBundleItems = previousBundleItems.map(item => {
        if (item?.bundleId === selectedBundlesProdctList[0]?.bundleId) {
          const data = {
            ...item,
            selectedSkus: [
              ...item.selectedSkus,
              ...selectedBundlesProdctList[0].selectedSkus,
            ],
          }
          data.selectedSkus = data.selectedSkus.filter(
            (value, index, array) => array.indexOf(value) === index
          )
          return data
        }

        return item
      })

      localStorage.setItem("bundleItems", JSON.stringify(newBundleItems))
    } else {
      const newBundleItems = [
        ...previousBundleItems,
        ...selectedBundlesProdctList,
      ]
      localStorage.setItem("bundleItems", JSON.stringify(newBundleItems))
    }
  }
}
